import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback: React.FC = () => {
  const { refreshUser } = useAuth();
  const [done, setDone] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('error')) {
      setError(true);
      return;
    }
    // The backend redirects to /dashboard directly after setting the cookie.
    // This page handles edge cases (e.g. if frontend routes to /auth/callback).
    refreshUser()
      .then(() => setDone(true))
      .catch(() => setError(true));
  }, [refreshUser]);

  if (error) return <Navigate to="/login?error=auth_failed" replace />;
  if (done) return <Navigate to="/dashboard" replace />;

  return (
    <div className="auth-callback">
      <div className="auth-callback-card">
        <div className="spinner" />
        <p>Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
